export default __webpack_public_path__ + "static/media/project-img-3.95d357e9.png";